// The hooldusplaat look's typeface. Loaded only when a page draws that look,
// so the original look never fetches it. The font files ship with the app
// (@fontsource-variable/archivo) instead of coming from Google Fonts, so a
// page view sends no visitor IP address to Google (GDPR). The family is
// 'Archivo Variable'; the plate CSS names it first.
let loaded = null

export default function loadArchivo () {
  if (!loaded) loaded = import('@fontsource-variable/archivo/standard.css')
  return loaded
}
